// extracted by mini-css-extract-plugin
export default {"formHeading":"CL-z","form":"DL-z","submitBtn":"EL-z","disabled":"FL-z","input":"GL-z","error":"HL-z","submitMsg":"IL-z","signIn":"JL-z"};